import { Info } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

// Long explanations, closed by default: the page shows the essentials, details one click away.
export function Explain({ title = "Come funziona", children, testid }) {
  return (
    <Accordion type="single" collapsible className="rounded-lg border border-slate-200 bg-white px-4" data-testid={testid}>
      <AccordionItem value="x" className="border-b-0">
        <AccordionTrigger className="py-3 text-left text-sm font-semibold text-slate-900 hover:no-underline" data-testid={testid && `${testid}-toggle`}>
          <span className="flex items-center gap-2"><Info size={16} className="shrink-0 text-sky-700" />{title}</span></AccordionTrigger>
        <AccordionContent className="pb-4 text-sm text-slate-800">{children}</AccordionContent>
      </AccordionItem>
    </Accordion>);
}

// Feature not available yet: one short, calm box instead of forms or long texts.
export function NotAvailable({ title, text, testid }) {
  return (
    <div className="flex flex-col items-start gap-2 rounded-xl border border-dashed border-slate-300 bg-white p-4 sm:flex-row sm:gap-3" data-testid={testid}>
      <span className="mt-0.5 shrink-0 whitespace-nowrap rounded-full bg-slate-100 px-2 py-0.5 text-xs font-semibold text-slate-700">Non ancora disponibile</span>
      <div className="min-w-0"><p className="font-semibold text-slate-900">{title}</p>{text && <p className="mt-0.5 text-sm text-slate-700">{text}</p>}</div>
    </div>);
}
